'use client';

import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { fr } from 'date-fns/locale';

import { getQueryClient } from '@/app/get-query-client';

import { DialogProvider, SessionProvider, ToastProvider, UserProvider } from '@/providers';

import theme from './theme';

export function Providers({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const queryClient = getQueryClient();
  return (
    <SessionProvider>
      <UserProvider>
        <QueryClientProvider client={queryClient}>
          <AppRouterCacheProvider>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                <ToastProvider>
                  <DialogProvider>
                    {children}
                    <ReactQueryDevtools />
                  </DialogProvider>
                </ToastProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </AppRouterCacheProvider>
        </QueryClientProvider>
      </UserProvider>
    </SessionProvider>
  );
}
